import { render, staticRenderFns } from "./WPInfoBlock.vue?vue&type=template&id=1b3709a9"
import script from "./WPInfoBlock.vue?vue&type=script&lang=ts"
export * from "./WPInfoBlock.vue?vue&type=script&lang=ts"
import style0 from "./WPInfoBlock.vue?vue&type=style&index=0&id=1b3709a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports